class DeliveryFeeService {
    constructor(restangular) {
        this.api = restangular.one('Delivery');
    }

    getDeliveryFeeStructure() {
        return this.api.one('DeliveryFeeStructure').get();
    }
}

DeliveryFeeService.$inject = ['Restangular'];

module.exports = DeliveryFeeService;



// WEBPACK FOOTER //
// ./src/fulfilment/delivery-fee.service.js